import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Select from "react-select";

export default function Lpg() {
  const billerOption = [
    { value: '10', label: 'Adani Electricity Mumbai Limited' },
    { value: '54', label: 'Ajmer Vidyut Vitran Nigam Ltd' },
    { value: '75', label: 'APEPDCL - Eastern Power Distribution CO AP Ltd.' },
  ];
  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main
          className="adminuiux-content has-sidebar"
        >
          {/*mt-4*/}
          <div className="container " id="main-content">
            <div className="row align-items-center">
              {/* <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Total Profit</p>
                          <h4 class="mb-3">$13.20k</h4><span class="badge badge-light text-bg-success"><i class="me-1 bi bi-arrow-up-short"></i>28.50%</span></div>
                  </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Best Profit</p>
                          <h4 class="mb-3">$8.34k</h4><span class="badge badge-light text-bg-success"><i class="me-1 bi bi-arrow-up-short"></i>54.35%</span></div>
                  </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Top Loser</p>
                          <h4 class="mb-3">-$5.15k</h4><span class="badge badge-light text-bg-danger"><i class="me-1 bi bi-arrow-down-short"></i>18.25%</span></div>
                  </div>
              </div> */}
            </div>
            <link
              href="https://kiaraapay.com/Aimra/css/select2.min.css"
              rel="stylesheet"
            />
            <input type="hidden" id="pcount" />
            <input type="hidden" id="refId" />
            <input type="hidden" id="user_id" defaultValue={12279} />
            <input type="hidden" id="mtime" />
            <input type="hidden" id="bill_data" />
            {/* dashboard inner */}
            <div className="midde_cont">
              <div className="container-fluid">
                <div className="row column_title">
                  <div className="col-md-12">
                    <div className="page_title d-sm-flex p-3">
                      <h2>Bill Pay (Online)</h2>
                      <marquee width="90%">
                        <h4>
                          <p>
                            <strong>
                              <span style={{ color: "#ffffff" }}>
                                <span style={{ fontSize: 24 }}>
                                  welcome to bill payment
                                </span>
                              </span>
                            </strong>
                          </p>
                        </h4>
                      </marquee>
                    </div>
                  </div>
                </div>
                <div className="row match-height">
                  <div className="col-xl-5 col-lglg-5 col-md-5 col-sm-5 col-12 mg-t-20">
                    <div className="form-group">
                      <label htmlFor="first-name-vertical">Service</label>
                      <select
                        className="form-control"
                        name="forma"
                        onchange="location = this.value;"
                      >
                        <option value="https://kiaraapay.com/v4/kiara/bill-pay">
                          Electricity
                        </option>
                        <option value="https://kiaraapay.com/v4/kiara/water">
                          Water
                        </option>
                        <option value="https://kiaraapay.com/v4/kiara/gas">Gas</option>
                        <option value="https://kiaraapay.com/v4/kiara/lpg" selected="">
                          Lpg
                        </option>
                        <option value="https://kiaraapay.com/v4/kiara/emi">EMI</option>
                        <option value="https://kiaraapay.com/v4/kiara/insurance">
                          Insurance
                        </option>
                        <option value="https://kiaraapay.com/v4/kiara/municipality">
                          Municipality
                        </option>
                        <option value="https://kiaraapay.com/v4/kiara/cable">
                          Cable
                        </option>
                        <option value="https://kiaraapay.com/v4/kiara/broadband-postpaid">
                          Broadband Postpaid
                        </option>
                        {/*<option value="https://kiaraapay.com/v4/kiara/mobile-postpaid">Mobile Postpaid</option>*/}
                        {/*<option value="https://kiaraapay.com/v4/kiara/landline-postpaid">Landline Postpaid</option>*/}
                        <option value="https://kiaraapay.com/v4/kiara/datacard-prepaid">
                          Datacard Prepaid
                        </option>
                        {/*<option value="https://kiaraapay.com/v4/kiara/datacard-postpaid">Datacard Postpaid</option>*/}
                        {/*<option value="https://kiaraapay.com/v4/kiarabbps/fastag-offline">Fastag</option> */}
                      </select>
                    </div>
                  </div>
                  <div className="col-7 mg-t-20" />
                  <div className="col-md-5 col-12 mt-4">
                    <div className="card adminuiux-card">
                      {/* <div class="card-header">
          </div> */}
                      <div className="card-content">
                        <div className="card-body">
                          <input
                            type="hidden"
                            name="_token"
                            defaultValue="DGyDvczUJzdSGbFAAxNsYxRPRNHBwoUIvt2tJL1u"
                          />{" "}
                          <div className="form-body">
                            <div className="row">
                              <div className="col-12 mg-t-20">
                                <div className="form-group">
                                  <label htmlFor="first-name-vertical">
                                    Biller Name
                                  </label>
                                  <Select options={billerOption} />
                                </div>
                              </div>
                              <div className="col-12 mt-2" id="form-data"></div>
                              <div className="col-12 mt-2">
                                <button
                                  style={{ display: "none" }}
                                  id="fetch_btn"
                                  className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                  onclick="billFetch()"
                                >
                                  Fetch Bill
                                </button>
                              </div>
                              <div className="col-12 mt-2" style={{ display: "none" }}>
                                <button
                                  style={{}}
                                  id="quick_pay"
                                  className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                  onclick="paynow()"
                                >
                                  Quick Pay
                                </button>
                              </div>
                              <div className="col-12 mt-2">
                                <button
                                  style={{ display: "none" }}
                                  id="pay_btn"
                                  className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                  onclick="paynow()"
                                >
                                  Pay Now
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7">
                    {/*<img src="http://aimra-money.com/bbps-new.jpg" class="float-right" height="100px;">*/}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="receiptModal"
              tabIndex={-1}
              aria-labelledby="receiptModal"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header bg-theme-1-subtle	">
                    <p className="modal-title h5" id="receiptModal">
                      Bill Fetch
                    </p>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-12">
                        {/*<img src="https://kiaraapay.com/bbps-new.jpg" class="float-right" style="height:80px; ">*/}
                      </div>
                      <input type="hidden" id="accountHolderName" />
                      <input type="hidden" id="amountDetails" />
                      <input type="hidden" id="additionalParams" />
                      <input type="hidden" id="billerId" />
                      <input type="hidden" id="dueDate" />
                      <input type="hidden" id="billDate" />
                      <div
                        className="col-12 mg-t-10"
                        id="detail_bx"
                        style={{ display: "none" }}
                      >
                        <div className="form-group">
                          <span>Biller Name</span>{" "}
                          <span className="float-right billerName" />
                          <br />
                          <span>Customer Name</span>{" "}
                          <span className="accountHolderName float-right" /> <br />
                          <span>Due Date</span> <span className="dueDate float-right" />
                          <br />
                          <span>Bill Date</span>{" "}
                          <span className="billDate float-right" />
                          <br />
                          <span>Bill Amount</span>{" "}
                          <span className="float-right amount" />
                        </div>
                      </div>
                      <div
                        className="col-12 mt-2"
                        style={{ display: "none" }}
                        id="amount_bx"
                      >
                        {/*<div class="form-group">
                                              <label for="amount">Customer Convennience Fee</label>
                                              <input type="text" value="0" placeholder="Amount" readonly class="form-control">
                                          </div>*/}
                        <div className="form-group mt-2">
                          <label htmlFor="amount">Amount</label>
                          <input
                            type="text"
                            id="amount"
                            readOnly=""
                            placeholder="Amount"
                            className="form-control"
                          />
                        </div>
                        <div className="form-group mt-2">
                          <label htmlFor="amount">Mpin</label>
                          <input
                            type="password"
                            id="bbps_pin"
                            placeholder="Mpin"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-theme" onclick="paynow()">
                      Confirm
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="position-fixed bottom-0 end-0 m-3 z-index-5">
              {/*<button class="btn btn-square btn-theme shadow" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i class="bi bi-palette"></i></button>*/}
              <br />
              <button
                className="btn btn-theme btn-square rounded-circle shadow mt-2 d-none"
                id="backtotop"
              >
                <i className="bi bi-arrow-up" />
              </button>
            </div>
            <div
              className="offcanvas offcanvas-end shadow border-0"
              tabIndex={-1}
              id="theming"
              data-bs-scroll="true"
              data-bs-backdrop="false"
              aria-labelledby="theminglabel"
            >
              <div className="offcanvas-header border-bottom">
                <div>
                  <h5 className="offcanvas-title" id="theminglabel">
                    Personalize
                  </h5>
                  <p className="text-secondary small">Make it more like your own</p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                />
              </div>
              <div className="offcanvas-body">
                <h6 className="offcanvas-title">Colors</h6>
                <p className="text-secondary small mb-4">Change colors of templates</p>
                <div className="row mb-4 theme-select">
                  <div className="col-auto">
                    <div className="select-box text-center mb-2" data-title="">
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                        <i className="bi bi-arrow-clockwise" />
                      </span>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-blue"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-blue" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-indigo"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-indigo" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-purple"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-purple" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-pink"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-pink" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="select-box text-center mb-2" data-title="theme-red">
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-red" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-orange"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-orange" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-yellow"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-yellow" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-green"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-green" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-teal"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-teal" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-cyan"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-cyan" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-grey"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-grey" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-brown"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-brown" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-chocolate"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-chocolate" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="theme-black"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-dark" />
                    </div>
                  </div>
                </div>
                <h6 className="offcanvas-title">Backgrounds</h6>
                <p className="text-secondary small mb-4">Change color for background</p>
                <div className="row mb-4 theme-background">
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-default"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                        <i className="bi bi-arrow-clockwise" />
                      </span>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-white"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-white" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-r-gradient"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-r-gradient" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-1"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-1" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-2"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-2" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-3"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-3" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-4"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-4" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-5"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-5" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-6"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-6" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-7"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-7" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-8"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-8" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-9"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-9" />
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="gradient-box text-center mb-2"
                      data-title="bg-gradient-10"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-10" />
                    </div>
                  </div>
                </div>
                <h6 className="offcanvas-title">Sidebar Layout</h6>
                <p className="text-secondary small mb-4">Change sidebar layout style</p>
                <div className="row mb-4 sidebar-layout">
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="adminuiux-sidebar-standard"
                      data-bs-toggle="tooltip"
                      aria-label="None"
                      data-bs-original-title="None"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                        <i className="bi bi-arrow-clockwise" />
                      </span>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="adminuiux-sidebar-iconic"
                      data-bs-toggle="tooltip"
                      aria-label="Iconic"
                      data-bs-original-title="Iconic"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                        <i className="bi bi-bezier h4" />
                      </span>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="adminuiux-sidebar-boxed"
                      data-bs-toggle="tooltip"
                      aria-label="Boxed"
                      data-bs-original-title="Boxed"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                        <i className="bi bi-box h5" />
                      </span>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div
                      className="select-box text-center mb-2"
                      data-title="adminuiux-sidebar-boxed adminuiux-sidebar-iconic"
                      data-bs-toggle="tooltip"
                      aria-label="Iconic+Boxed"
                      data-bs-original-title="Iconic+Boxed"
                    >
                      <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                        <i className="bi bi-bounding-box h5" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-center mb-4">
                  <a
                    href="investment-personalization.html"
                    className="btn btn-sm btn-outline-theme"
                  >
                    More options <i className="bi bi-arrow-right-short" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}